export enum EACTIONTABLE {
  DELETE = 'DELETE',
  EDIT = 'EDIT',
  RESET_PASS = 'RESET_PASS',
  CONFIRM_INSPECTOR = 'CONFIRM_INSPECTOR',
}
